export default function HotDesk() {
  return (
    <>
      <h1 className="h1">hi</h1>
    </>
  )
}